import { takeLatest, call, put } from 'redux-saga/effects';
import { message } from 'antd';
import { UPLOAD_AGENCY_TEST_CSV_REQUEST } from 'constants/ClientCompanyTestDirectory';
import {
  uploadAgencyTestCsvSuccess,
  uploadAgencyTestCsvFailure
} from 'redux/actions/ClientCompanyTestDirectory';
import AgencyTestCsvService from 'services/AgencyTestCsvService';
import { UNPROCESSABLE_ENTITY_CODE } from 'configs/AppConfig';

function* onUploadAgencyTestCsv({ payload }) {
  try {
    const result = yield call(AgencyTestCsvService.upload, { formData: payload });

    // 2xx JSON response path
    if (result.status) {
      yield put(uploadAgencyTestCsvSuccess(result.data));
      message.success('Bulk assign succeeded');

    } else if (result.code === UNPROCESSABLE_ENTITY_CODE) {
      // extract both Laravel "errors" and any "validation_errors"
      const errs = [];
      if (result.data.errors) {
        Object.values(result.data.errors).forEach(arr => errs.push(...arr));
      }
      (result.data.validation_errors || []).forEach(e => errs.push(e));

      errs.forEach(e => message.error(e));
      yield put(uploadAgencyTestCsvFailure(errs));

    } else {
      message.error(result.message || 'Bulk assign failed');
      yield put(uploadAgencyTestCsvFailure(result.message));
    }

  } catch (e) {
    if (e.response && e.response.status === UNPROCESSABLE_ENTITY_CODE) {
      const errs = [];
      if (e.response.data.errors) {
        Object.values(e.response.data.errors).forEach(arr => errs.push(...arr));
      }
      (e.response.data.validation_errors || []).forEach(e => errs.push(e));

      errs.forEach(e => message.error(e));
      yield put(uploadAgencyTestCsvFailure(errs));

    } else {
      message.error('Bulk assign failed: ' + (e.message || 'Unknown error'));
      yield put(uploadAgencyTestCsvFailure(e.message));
    }
  }
}

export function* watchUploadAgencyTestCsv() {
  yield takeLatest(UPLOAD_AGENCY_TEST_CSV_REQUEST, onUploadAgencyTestCsv);
}